import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const BabyCarIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M54.66 140.004C50.253 140.004 46.6602 136.411 46.6602 132.004C46.6602 127.597 50.253 124.004 54.66 124.004C59.0675 124.004 62.66 127.597 62.66 132.004C62.66 136.411 59.0675 140.004 54.66 140.004Z"
                stroke={color}
                strokeWidth="6"
                strokeMiterlimit="10"
            />
            <path
                d="M92.0039 140.004C87.5964 140.004 84.0039 136.411 84.0039 132.004C84.0039 127.597 87.5964 124.004 92.0039 124.004C96.4109 124.004 100.004 127.597 100.004 132.004C100.004 136.411 96.4109 140.004 92.0039 140.004Z"
                stroke={color}
                strokeWidth="6"
                strokeMiterlimit="10"
            />
            <path
                d="M20 67.998H118.311C121.453 67.998 124 70.545 124 73.687C124 94.109 107.444 110.664 87.022 110.664H62.6665C39.1026 110.664 20 91.562 20 67.998Z"
                stroke={color}
                strokeWidth="6"
            />
            <path
                d="M20 68C20 41.4904 41.8373 20 68.347 20C69.619 20 70.6665 21.0311 70.6665 22.303V58C70.6665 63.523 66.1895 68 60.6665 68H20Z"
                stroke={color}
                strokeWidth="6"
            />
            <path d="M122.5 70C122.5 58.9545 131.454 50 142.5 50" stroke={color} strokeWidth="6" strokeLinecap="round" />
        </svg>
    );
};
